import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { HelperText01, ProductiveHeading07 } from 'components/styles';

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-left: var(--spacing-05);
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: var(--spacing-05);

  ${Button} {
    flex: 1;
  }
`;

export const OptionTitle = styled.div`
  ${ProductiveHeading07};
`;

export const OptionHelperText = styled.div`
  ${HelperText01};
`;

export const EffectiveDateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;
export const EffectiveFrom = styled.span`
  color: var(--gray-50);
`;
